// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"103":"64d553d0","406":"94cd62a0","828":"94cd62a0","829":"94cd62a0"}[chunkId] + ".chunk.css";
};